import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

// Исторический адрес входа заказчика. Экран входа один на экосистему
// (22-unified-login), поэтому здесь только редирект — закладки и старые ссылки
// продуктов продолжают работать, ?rd= и повод визита не теряются.
const LegacySearchSchema = z.object({
  rd: z.string().optional(),
  notice: z.enum(['expired', 'signedout']).optional(),
})

export const Route = createFileRoute('/_public/customer/login')({
  validateSearch: (search: Record<string, unknown>) => LegacySearchSchema.parse(search),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/login',
      search: {
        ...(search.rd ? { rd: search.rd } : {}),
        ...(search.notice ? { notice: search.notice } : {}),
      },
      replace: true,
    })
  },
})
